export const notificationPathByMessage = (type, id, source_table) => {
  switch (type) {
    case 'contact-request-new':
      return '/profile/message/request'
    case 'contact-request-accepted':
      return '/profile/message/request'
    case 'contact-request-rejected':
      return '/profile/message/request'
    case 'filter-match':
      return '/seller'
    case 'profile-accepted':
      if (source_table == 'seller_profiles') {
        return '/profile/company-for-sale'
      } else if (source_table == 'buyer_profiles') {
        return '/profile/wanted-company'
      } else {
        return '/profile/advisor-information'
      }
    case 'profile-rejected':
      if (source_table == 'seller_profiles') {
        return '/profile/company-for-sale'
      } else if (source_table == 'buyer_profiles') {
        return '/profile/wanted-company'
      } else {
        return '/profile/advisor-information'
      }
    case 'payment-pending':
      return `/profile/transaction/${id}/detail-transaction`
    case 'payment-accepted-sponsorship':
      return `/profile/transaction/${id}/detail-transaction`
    case 'payment-accepted-extra-bundle':
      return `/profile/transaction/${id}/detail-transaction`
    case 'payment-accepted-event':
      return `/profile/transaction/${id}/detail-transaction`
    case 'payment-accepted':
      return `/profile/transaction/${id}/detail-transaction`
    default:
      break
  }
}
